export default __webpack_public_path__ + "e4998037e9364bc7c8308d02b97eff35.png";